import * as React from "react";
import { LiveTableBodyColumn } from "../LiveTableBodyColumn";
export const TeamScores = (props) => {
    const { scores, teamName } = props;
    return (React.createElement("tr", { className: "rj-scoreboard__live-table-body-row", "data-uat": "scoreboard-live-table-body-row" },
        React.createElement("td", { className: "rj-scoreboard__live-team-name-wrapper" },
            React.createElement("div", { className: "rj-scoreboard__live-team-name-container" },
                React.createElement("span", { className: "rj-scoreboard__live-team-name" }, teamName))),
        scores.map((value, index) => React.createElement(LiveTableBodyColumn, Object.assign({}, { value, index }, { key: `team-score-${index}` })))));
};
//# sourceMappingURL=TeamScores.js.map